import EventCardPlate from './EventCardPlate';

export { EventCardPlate };
export default EventCardPlate;
